// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a36665a3","977":"59fb7421"}[chunkId] + ".chunk.js";
};